import React, { useEffect, useRef } from "react";

const easeOutQuad = (t) => t * (2 - t);

const AnimatedNumbers = ({
    value,
    duration = 1000,
    decimals = 0,
    prefix = "",
    suffix = "",
    className = "",
}) => {
    const ref = useRef();
    const currentValue = useRef(0);
    const animationRef = useRef();

    useEffect(() => {
        const start = currentValue.current;
        const target = value;
        const startTime = performance.now();

        const animate = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeOutQuad(progress);
            const newValue = start + (target - start) * eased;

            if (ref.current) {
                const formattedValue =
                    value === 0
                        ? `${prefix}${newValue.toFixed(2)}${suffix}`
                        : `${prefix}${newValue.toFixed(decimals)}${suffix}`;
                ref.current.textContent = formattedValue;
            }

            if (progress < 1) {
                animationRef.current = requestAnimationFrame(animate);
            } else {
                currentValue.current = target;
            }
        };

        cancelAnimationFrame(animationRef.current);
        animationRef.current = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationRef.current);
    }, [value, duration, decimals, prefix, suffix]);

    return <span ref={ref} className={className} />;
};

export default AnimatedNumbers;
